import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { RecommendationType } from '../../../types/common';

interface StyledCarouselContainerProps {
  type: string;
}

export const StyledCarouselContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'type',
})<StyledCarouselContainerProps>(({ theme, type }) => ({
  padding: '1rem',
  flex: 1,
  minHeight: '100vh',
  width: '100%',
  overflow: 'hidden',
  backgroundColor: theme.palette.common.white,
  ...(type === RecommendationType.SEARCH_START_TOP_PICKS && {
    paddingLeft: '0',
    paddingRight: '0',
  }),
}));

export const LeoCardSkeletonContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  display: 'flex',
  flexDirection: 'column',
  minWidth: theme.spacing(25),
  height: theme.spacing(56.375),
  padding: theme.spacing(1),
  '&.compact': {
    minWidth: theme.spacing(18),
    height: theme.spacing(30),
    width: theme.spacing(18),
  },
  '&.compact_mini': {
    minWidth: theme.spacing(12),
    height: theme.spacing(19.5),
    width: theme.spacing(13.5),
    padding: theme.spacing(0.5),
  },
  [theme.breakpoints.down('sm')]: {
    minWidth: theme.spacing(20),
    height: theme.spacing(47.5),
    '&.compact': {
      minWidth: theme.spacing(13.5),
      height: theme.spacing(24),
      width: theme.spacing(13.5),
    },
    '&.compact_mini': {
      minWidth: theme.spacing(12),
      height: theme.spacing(18),
      width: theme.spacing(12),
      padding: theme.spacing(0.5),
    },
  },
  '&.vertical_list': {
    minWidth: theme.spacing(12),
    height: theme.spacing(26.5),
    gridTemplateColumns: 'repeat(3, 1fr)',
    padding: theme.spacing(1),
  },
  borderRadius: theme.spacing(2),
}));

export const SkeletonImageContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: theme.spacing(25),
  '&.compact': {
    height: theme.spacing(18),
    flexShrink: 0,
    border: `${theme.spacing(0.125)} solid ${theme.palette.grey[100]}`,
    borderRadius: theme.spacing(2),
  },
  '&.compact_mini': {
    height: theme.spacing(12.25),
    flexShrink: 0,
    border: `${theme.spacing(0.125)} solid ${theme.palette.grey[100]}`,
    borderRadius: theme.spacing(2),
  },
  [theme.breakpoints.down('sm')]: {
    height: theme.spacing(20),
    '&.compact': {
      height: theme.spacing(13.5),
    },
    '&.compact_mini': {
      height: theme.spacing(12.25),
    },
  },
}));

export const SkeletonContentContainer = styled(Box)(() => ({
  width: '100%',
  flexGrow: '1',
}));

export const SkeletonWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.2),
  paddingRight: 0,
  paddingBottom: theme.spacing(1.2),
  marginLeft: 0,
}));

export const SkeletonRectLeo = styled('rect')(({ theme }) => ({
  x: theme.spacing(1),
  rx: theme.spacing(0.5),
  ry: theme.spacing(0.5),
  width: `calc(100% - ${theme.spacing(2)})`,
  y: theme.spacing(1),
  height: theme.spacing(2.5),
  '&.compact': {
    display: 'none',
  },
  '&.compact_mini': {
    display: 'none',
  },
  '&.first': {
    width: theme.spacing(7.625),
  },
  '&.second': {
    y: theme.spacing(5),
    height: theme.spacing(6),
  },
  '&.third': {
    y: theme.spacing(12),
    height: theme.spacing(5),
  },
  '&.fourth': {
    y: theme.spacing(18.5),
    height: theme.spacing(12),
  },
  '&.first.compact': {
    display: 'block',
    x: theme.spacing(1),
    height: theme.spacing(6),
    width: `calc(100% - ${theme.spacing(2)})`,
  },
  '&.second.compact': {
    display: 'block',
    x: theme.spacing(1),
    y: theme.spacing(7.5),
    width: theme.spacing(12.125),
    height: theme.spacing(4.125),
  },
  '&.first.compact_mini': {
    display: 'block',
    x: 0,
    y: 20,
    height: theme.spacing(6),
    width: theme.spacing(20),
  },
}));
